// 管理员密码（简单验证，存储在环境变量中，构建时注入）
// 实际使用中请修改此密码，或通过环境变量设置
const ADMIN_PASSWORD = import.meta.env.VITE_ADMIN_PASSWORD || 'admin123456';

export function getAdminPassword(): string {
  return ADMIN_PASSWORD;
}

// 检查当前 session 是否为管理员
// 使用 localStorage，实现「登录一次，所有页面都能用」
export function isAdminSession(): boolean {
  return localStorage.getItem('contract_admin_auth') === 'true';
}

// 管理员登录
export function adminLogin(password: string): boolean {
  if (password === ADMIN_PASSWORD) {
    localStorage.setItem('contract_admin_auth', 'true');
    return true;
  }
  return false;
}

// 管理员登出
export function adminLogout(): void {
  localStorage.removeItem('contract_admin_auth');
}

// 管理员密码验证（用于 API 路由保护，此项目为纯前端，仅做前端校验）
export function requireAdmin(): boolean {
  return isAdminSession();
}
